module.exports = __webpack_public_path__ + "img/402fd21.jpg";